import "../../base/pages/fundraising";
$(document).ready(function () {
  $("#donator_donation_transactions_attributes_0_amount").on(
    "input",
    function () {
      const amount = $("#donator_donation_transactions_attributes_0_amount")
        .val()
        .replace(/\./g, "")
        .replace(/\,/g, ".");
      const currency = $("#currency-type").val();
      const amount_triggers = { clp: 2000, usd: 2, uf: 0.05 };
      if (amount >= amount_triggers[currency]) {
        $("#reward-checkbox-container").show();
      } else {
        $("#reward-checkbox-container").hide();
        $("#reward-checkbox").prop("checked", false);
        $("#reward-checkbox").trigger("change");
      }
    }
  );

  $("#currency-type").on("change", function () {
    $("#donator_donation_transactions_attributes_0_amount").trigger("input");
  });

  $("#reward-checkbox").on("change", function () {
    if (this.checked) {
      $("#donator_donation_transactions_attributes_0_description").val(
        "Participa por premio"
      );
      $("#firstname_form").show();
      $("#donator_name").prop("required", true);
      $("#lastname_form").show();
      $("#donator_last_name").prop("required", true);
      $("#donator_email_fundraising").prop("required", true);
      $("#donator_email_fundraising").prop("required", true);
      $("#donator_email_label").html("Ingresa tu mail");
      $("#donator_email_fundraising").addClass("form-control", true);
    } else {
      $("#donator_donation_transactions_attributes_0_description").val("");
      $("#firstname_form").hide();
      $("#donator_name").prop("required", false);
      $("#lastname_form").hide();
      $("#donator_last_name").prop("required", false);
      if ($("#recurring-checkbox")[0].checked) {
        $("#donator_email_fundraising").prop("required", true);
        $("#donator_email_label").html("Ingresa tu mail");
        $("#donator_email_fundraising").addClass("form-control", true);
      } else {
        $("#donator_email_fundraising").prop("required", false);
        $("#donator_email_label").html(
          "Ingresa tu mail <span class='optional'>(Opcional)</span>"
        );
        $("#donator_email_fundraising").removeClass("form-control", true);
      }
    }
  });
});
